if (!customElements.get('ct-product')) {
  customElements.define(
    'ct-product',
    class CTProduct extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          mainSwiperDiv: null,
          mainSwiper: null,
          thumbsSwiperDiv: null,
          thumbsSwiper: null,
          productOverlay: null
        }
      }

      connectedCallback() {

        this.elements.mainSwiperDiv = this.querySelector('.swiper');
        this.elements.thumbsSwiperDiv = this.querySelector('.swiper--thumbs');

        // Initialize Swipers if the necessary elements are present
        if (this.elements.mainSwiperDiv && this.elements.thumbsSwiperDiv) {
          this.init();
        }
      }

      init() {
        // Initialize thumbs Swiper
        this.elements.thumbsSwiper = new Swiper(this.elements.thumbsSwiperDiv, {
          spaceBetween: 5,
          slidesPerView: 3.5,
          watchSlidesProgress: true,
          freeMode: true,
          loop: true,
        });

        // Initialize main Swiper with thumbs control
        this.elements.mainSwiper = new Swiper(this.elements.mainSwiperDiv, {
          spaceBetween: 5,
          slidesPerView: 1,
          loop: true,
          thumbs: {
            swiper: this.elements.thumbsSwiper
          }
        });

        this.elements.productOverlay = this.querySelector('.ct-product__overlay');

        if(this.elements.productOverlay) {
          this.elements.productOverlay.addEventListener('click', () => {
            document.body.classList.remove('size-chart-is-open');
          });
        }
        
      }

    }
  );
}



